// config.js
const config = {
    contactEmail: process.env.REACT_APP_CONTACT_EMAIL || "default_email@example.com",
    contactEmail1: process.env.REACT_APP_CONTACT_EMAIL1 || "default_email@example.com",
    contactName: process.env.REACT_APP_CONTACT_NAME || "default_name",
    myDesignation: process.env.REACT_APP_MY_DESIGNATION || "consultant",
    myCurrentRole: process.env.REACT_APP_MY_CURRENT_ROLE || "Developer",
 
    myAddress1: process.env.REACT_APP_MY_ADDRESS1 || "Address 1",
    myAddress2: process.env.REACT_APP_MY_ADDRESS2 || "Address 2",
    myPhoneNumber: process.env.REACT_APP_MY_PHONE_NUMBER || "091 1234567890",
    contactFacebookLink: process.env.REACT_APP_MY_FACEBOOK_LINK || "FACEBOOK URL",
    contactLinkedinLink: process.env.REACT_APP_MY_LINKEDIN_LINK || "LINKEDIN URL",
    contactXLink: process.env.REACT_APP_MY_X_URL || "TWITTER URL",
    contactArticlesLink: process.env.REACT_APP_MY_ARTICLES_URL || "Articles URL",
    mySkills: process.env.REACT_APP_MY_SKILLS || "SKILLS",
    mySkills1: process.env.REACT_APP_MY_SKILLS1 || "SKILLS",
    myDomainUrl: process.env.REACT_APP_MY_DOMAIN_URL || "SKILLS",
    myCertificate: process.env.REACT_APP_MY_CERTIFICATE || "SKILLS",
    myDeploma: process.env.REACT_APP_MY_DEPLOMA || "SKILLS",
    myDegree1: process.env.REACT_APP_MY_DEGREE1 || "SKILLS",
    myDegree2: process.env.REACT_APP_MY_DEGREE2 || "SKILLS",
    

    

  };
  
  export default config;
  